<template>
  <div class="summary">
    <div class="summary-top">
      <div class="summary-top__left">
        <img src="../../assets/img/logo3.png" alt="" class="summary-top__logo">
        <div class="summary-top__text">非店铺授权版</div>
        <div
          class="summary-top__item"
          :class="{'summary-top__item--underline' : item.underline}"
          @click="summaryTopClick(item.type)"
          v-for="item in commonFunctions"
          :key="item.id">
          {{ item.text }}
        </div>
      </div>
      <div class="summary-top__right">
        <el-badge is-dot>
          <img src="../../assets/img/提醒.png" alt="" class="summary-top__img">
        </el-badge>
        <img src="../../assets/img/头像1.png" alt="" class="summary-top__img">
        <el-dropdown trigger="click">
          <span class="el-dropdown-link">
            {{ userinfo.permissionName }}账户<i class="el-icon-arrow-down el-icon-caret-bottom"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item class="summary-top-dropdown" disabled>
              <div class="summary-top-dropdown__item">
                <img src="./img/shark.png" alt="" class="summary-top-dropdown__item__logo">
                <div>
                  <div class="summary-top-dropdown__item__line">会员ID:{{ userinfo.idString }}</div>
                  <div class="summary-top-dropdown__item__line">
                    {{ userinfo.permissionName }}
                    <span class="summary-top-dropdown__item__tip">(可管理5个店铺,共100个产品)</span>
                  </div>
                </div>
              </div>
            </el-dropdown-item>
            <el-dropdown-item class="summary-top-dropdown" disabled divided>
              <div class="summary-top-dropdown__item">
                <div>
                  <i class="el-icon-s-help i-left"></i>
                  使用期剩余：<span class="summary-top-dropdown__num">{{ userinfo.daysLeft }}天</span>
                </div>
              </div>
            </el-dropdown-item>
            <el-dropdown-item class="summary-top-dropdown" disabled divided>
              <div class="summary-top-dropdown__item">
                <div>
                  <i class="el-icon-bell i-left"></i>
                  可统计销售单剩余：<span class="summary-top-dropdown__num">12500个</span>
                </div>
              </div>
            </el-dropdown-item>
            <el-dropdown-item
              class="summary-top-dropdown"
              divided
              v-for="item in userMenu"
              :key="item.id">
              <div class="summary-top-dropdown__item" @click="menuItemClick(item.name, item.id)">
                <div>
                  <i class="i-left" :class="item.icon"></i>
                  {{ item.name }}
                </div>
                <i class="el-icon-arrow-right"></i>
              </div>
            </el-dropdown-item>
            <el-dropdown-item class="summary-top-dropdown" divided>
              <div class="summary-top-dropdown__item" @click="quitLogin">
                <div>
                  <i class="el-icon-switch-button i-left"></i>
                  退出登录
                </div>
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="summary-body">
      <div class="summary-body__left">
        <div class="summary-body-menu">
          <div
            class="summary-body-menu__item"
            :class="{'summary-body-menu__item--select': functionMenuSelect === fun.id}"
            v-for="fun in functionMenu"
            :key="fun.id"
            @mouseover="menuItemMouseHover(fun.id)">
            {{ fun.name }}
          </div>
        </div>
        <div class="summary-body-menu__modal" v-show="functionMenuShow"></div>
        <div
          class="summary-body-option"
          v-show="functionMenuShow"
          @mouseleave="menuItemMouseLeave()">
          <div
            class="summary-body-option__module"
            v-for="moduleItem in functionMenuOption"
            :key="moduleItem.id">
            {{ moduleItem.name }}
            <div
              class="summary-body-option__item"
              v-for="item in moduleItem.list"
              :key="item.id"
              @click="menuItemClick(item.name, item.id)">
              <template v-if="item.title">
                <div class="summary-body-option__item--title">{{ item.title }}</div>
              </template>
              {{ item.name }}
              <template v-if="item.num != null">
                (<span class="summary-body-option__item--num">{{ item.num }}</span>)
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="summary-body__right">
        <el-tabs type="card" closable v-model="tabData" @tab-remove="tabRemove">
          <el-tab-pane
            v-for="item in tabsList"
            :key="item.id"
            :label="item.name"
            :name="item.id"></el-tab-pane>
        </el-tabs>
        <keep-alive :include="cacheComponentArray">
          <component
            :is="tabData"
            class="summary-body-component"
            @delete="deleteComponent"
            @go="switchComponent"></component>
        </keep-alive>
        <copyright></copyright>
      </div>
    </div>
    <Dialog :show="dialogImgShow" @cancel="dialogImgShow = false">
      <img src="../../assets/img/流程2.png" alt="" class="summary-dialog__img">
    </Dialog>
  </div>
</template>

<script>
import { SummaryNewModule, summaryTab } from "common/dataClass/Summary";
import { UserInfo } from "common/dataClass/User";
import globalData from 'common/globalData'
import UserAxios from 'service/user'

import copyright from "components/content/copyright";
import Dialog from 'components/common/Dialog'
import summaryDashboard from './component/summaryDashboard/index';
import uploadSummaryReport from './component/summaryDashboard/report';
import productInfo from './component/productInfo/index';
import account from './component/account/index';
import newProductInfo from './component/newProductInfo/index';
import profitFromProductSelection from './component/profitFromProductSelection/index';
import newProfitFromProductSelection from './component/profitFromProductSelection/new';
import productSelectionCost from './component/profitFromProductSelection/cost';
import shopExpenseSettings from './component/shopExpenseSettings/index';
import summaryDateSetting from './component/summaryDateSetting/index';
import salesCommissionSetting from './component/salesCommissionSetting/index';
import listing from './component/listing/index';
import newListing from './component/listing/new';
import productProfit from './component/productProfit/index';
import costOfGoods from './component/productProfit/cost';
import serviceSupplierInfo from './component/serviceSupplier/index';
import newServiceSupplier from './component/serviceSupplier/new';
import applicationForExternalExpenses from './component/serviceSupplier/feeApply';
import orderQuantity from './component/orderQuantity/index'
import productSales from './component/productSales/index'
import salesTrendAnalysis from './component/salesTrendAnalysis/index'
import returnOrder from './component/order/return'
import swapOrder from './component/order/swap'
import removeOrder from './component/order/remove'
import discardOrder from './component/order/discard'
import FBAReplenishment from './component/FBAReplenishment/index'
import newFBAReplenishment from './component/FBAReplenishment/new'
import productReserves from './component/productReserves/index'
import newProductReserves from './component/productReserves/new'
import trafficAndReview from './component/dataAnalysis/review'
import advertisingAndSalesNum from './component/dataAnalysis/sales'
import purchasePlanSheet from './component/purchase/plan'
import purchaseOrderToBeSupplemented from './component/purchase/replenish'
import purchaseOrder from './component/purchase/order'
import purchaserInformation from './component/purchase/info'
import newProductSupplier from './component/productSupplier/new'
import productSupplierInfo from './component/productSupplier/info'
import warehouseRegistration from './component/warehouseAllocation/inLog'
import outboundRegistration from './component/warehouseAllocation/outLog'
import deliveryTask from './component/warehouseAllocation/deliveryTask'
import warehouseReceipt from './component/warehouseAllocation/inOrder'
import deliveryOrder from './component/warehouseAllocation/outOrder'
import productReserveInventory from './component/stockStatus/product'
import amazonProductInventory from './component/stockStatus/listing'
import totalInventory from './component/stockStatus/total'
import newWarehouse from './component/transitWarehouse/new'
import repositoryList from './component/transitWarehouse/index'
import logisticsPricing from './component/logisticsManagement/plan'
import pendingLogisticsOrders from './component/logisticsManagement/toBe'
import unpaidLogisticsOrders from './component/logisticsManagement/unpaid'
import theLogisticsOrderHasBeenPaid from './component/logisticsManagement/paid'

let functionMenu = SummaryNewModule.NEWFUNCTIONMENU()
export default {
  name: 'mySummary',
  components:{
    copyright, Dialog, summaryDashboard, uploadSummaryReport, productInfo, account, newProductInfo,
    profitFromProductSelection, newProfitFromProductSelection,
    shopExpenseSettings, productSelectionCost, summaryDateSetting,
    salesCommissionSetting, listing, newListing, productProfit, costOfGoods,
    serviceSupplierInfo, newServiceSupplier, orderQuantity, productSales,
    salesTrendAnalysis, returnOrder, swapOrder, removeOrder, discardOrder,
    FBAReplenishment, newFBAReplenishment, productReserves, newProductReserves,
    trafficAndReview, advertisingAndSalesNum, purchasePlanSheet, purchaseOrderToBeSupplemented,
    purchaseOrder, applicationForExternalExpenses, newProductSupplier, productSupplierInfo,
    purchaserInformation, warehouseRegistration, outboundRegistration, deliveryTask,
    warehouseReceipt, deliveryOrder, productReserveInventory, amazonProductInventory, totalInventory,
    newWarehouse, repositoryList, logisticsPricing, pendingLogisticsOrders, unpaidLogisticsOrders,
    theLogisticsOrderHasBeenPaid
  },
  data(){
    return{
      /**常用功能 */
      commonFunctions: SummaryNewModule.NEWFUNCTIONLIST(),
      /**左侧菜单目录 */
      functionMenu: functionMenu,
      functionMenuShow: false,
      functionMenuSelect: 'summary',
      /**标签页数据 */
      tabsList: [new summaryTab(
        functionMenu.summary.list.monthlySummary.list.summaryDashboard.name,
        functionMenu.summary.list.monthlySummary.list.summaryDashboard.id
      )],
      tabData: functionMenu.summary.list.monthlySummary.list.summaryDashboard.id,
      /**用户信息 */
      userinfo: new UserInfo(),
      /**用户菜单 */
      userMenu: SummaryNewModule.NEWUSERMENU(),
      /**组件参数默认数据 */
      defaultArgument: SummaryNewModule.DEFAULTARGUMENT(),
      /**弹窗图片 */
      dialogImgShow: false
    }
  },
  methods: {
    /**深拷贝 */
    deepClone: globalData.deepClone,
    /**顶部菜单点击事件 */
    summaryTopClick(type){
      if(type === 'dialog'){
        this.dialogImgShow = true
      }
    },
    /**左侧菜单Hover事件 */
    menuItemMouseHover(key){
      this.functionMenuSelect = key
      this.functionMenuShow = true
    },
    /**左侧菜单鼠标离开事件 */
    menuItemMouseLeave(){
      this.functionMenuShow = false
      this.findFatherId(this.tabData)
    },
    /**左侧菜单子项点击事件 */
    menuItemClick(name, id){
      if(!this.$options.components[id]){
        this.$message.warning('功能开发中')
        return;
      }
      let index = this.tabsList.findIndex(arr => arr.id === id)
      if(index === -1){
        this.tabsList.push(new summaryTab(name, id))
      }else{
        this.tabsList[index].name = name
      }
      this.tabData = id
      this.$store.commit('componentChange', {
        key: id,
        obj: this.defaultArgument[id]
      })
      this.menuItemMouseLeave()
      this.findFatherId(this.tabData)
    },
    /**通过组件找父级ID */
    findFatherId(id){
      if(id == undefined) return;
      let list = this.functionMenu
      Object.keys(list).forEach(obj => {
        Object.keys(list[obj].list).forEach(object => {
          Object.keys(list[obj].list[object].list).forEach(string => {
            if(string == id){
              this.functionMenuSelect = obj
              return
            }
          })
        })
      })
    },
    /**移除标签 */
    tabRemove(id){
      let index = this.tabsList.findIndex(arr => arr.id === id)
      if(this.tabsList.length === 1){
        this.tabsList.splice(0, 1)
        this.tabsList.push(new summaryTab(
          this.functionMenu.summary.list.monthlySummary.list.summaryDashboard.name,
          this.functionMenu.summary.list.monthlySummary.list.summaryDashboard.id
        ))
        this.tabData = this.functionMenu.summary.list.monthlySummary.list.summaryDashboard.id
      }else{
        if(this.tabData === this.tabsList[index].id){
          this.tabData = this.tabsList[index - 1].id
        }
        this.tabsList.splice(index, 1)
      }
    },
    /**退出登录 */
    async quitLogin(){
      let res = await UserAxios.logout()
      if(res.data.code === 1){
        this.$message.success(res.data.info)
        this.$router.replace('index')
      }
    },
    /**删除组件 */
    deleteComponent(obj){
      let id = obj.id
      let tab = obj.tab
      this.menuItemClick(tab.name, tab.id)
      this.tabRemove(id)
    },
    /**切换组件 */
    switchComponent(obj){
      let name = obj.name
      let id = obj.id
      this.menuItemClick(name, id)
      this.$store.commit('componentChange', {
        key: id,
        obj: obj.obj ? obj.obj : this.defaultArgument[id]
      })
    }
  },
  computed: {
    /**左侧菜单子项 */
    functionMenuOption(){
      if(this.functionMenuSelect == '') return {}
      // 必须深拷贝，不然会污染原数据
      let obj = this.deepClone(this.functionMenu[this.functionMenuSelect].list)
      let secondListKeys = Object.keys(obj)
      let thirdListKeys = [], tObj = {}
      secondListKeys.map(key => {
        tObj = obj[key].list
        thirdListKeys = Object.keys(tObj)
        thirdListKeys.map(tKey => {
          if(!tObj[tKey].isShow) delete tObj[tKey]
        })
        obj[key].list = tObj
      })
      return obj
    },
    /**缓存组件数组 */
    cacheComponentArray(){
      return this.tabsList.map(a => a.id)
    }
  },
  async created(){
    let funObj = {
      1: (obj) => {
        this.userinfo.role = obj.authorities[0].authority
        this.userinfo.expirationTime = obj.dealTime
      },
      1000: (obj) => {
        this.$message.error(obj)
        this.$router.replace('login')
      }
    }
    let res = await UserAxios.getUserinfo()
    funObj[res.data.code](res.data.info)
  }
}
</script>

<style lang="scss" scoped>
.summary-body__right{
  ::v-deep{
    .el-tabs__item.is-active{
      color: #00a0c7 !important;
    }
    .el-tabs--card>.el-tabs__header .el-tabs__nav{
      border: none !important;
    }
    .el-tabs__nav-scroll{
      background-color: #fff;
      height: 45px;
    }
    .el-tabs__item{
      font-size: 12px !important;
    }
    .el-tabs__nav-wrap.is-scrollable{
      background-color: #fff;
    }
    .el-tabs__item.is-active{
      background-color: #f1f4ff;
      height: 40px ;
      line-height: 40px ;
      margin: 5px 0 0;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
    }
    .el-tabs--card>.el-tabs__header .el-tabs__item.is-active{
      border-bottom-color: #f1f4ff !important;
    }
    .el-tabs__item{
      height: 42px ;
      line-height: 42x ;
    }
  }
}
</style>

<style lang="scss" scoped>
.summary{
  &-top{
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: content-box;
    height: 60px;
    background: #022028;
    color: white;
    z-index: 10;
    &__left{
      display: flex;
      align-items: center;
    }
    &__right{
      display: flex;
      align-items: center;
      margin-right: 50px;
      .el-dropdown-link{
        color: white;
        margin: 0 10px;
        font-weight: bold;
        font-size: 14px;
        &:hover{
          cursor: pointer;
          opacity: .8;
        }
      }
    }
    &__text{
      margin-left: 10px;
      padding: 0 10px;
      border-left: 1px solid white;
      font-weight: bold;
    }
    &__logo{
      width: 160px;
      padding-bottom: 7px;
    }
    &__item{
      color: #0ea6b3;
      margin: 0 10px;
      &--underline{
        text-decoration: underline;
      }
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
    &__img{
      width: 25px;
      height: 25px;
      margin-left: 20px;
    }
    &-dropdown{
      &__item{
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #606266;
        font-size: 12px;
        &__logo{
          height: 36px;
          margin: 0 5px;
        }
        &__line{
          line-height: 18px;
        }
        &__tip{
          color: #28b9cb;
          font-size: 10px;
        }
      }
      &__num{
        color: #28b9cb;
      }
    }
  }
  &-body{
    position: relative;
    display: flex;
    &-menu{
      position: relative;
      z-index: 10;
      min-height: calc(100vh - 60px);
      height: 100%;
      background: #022028;
      width: 80px;
      color: white;
      &__item{
        width: 80px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        &:hover{
          cursor: pointer;
          opacity: .8;
          background: #27b8d0;
        }
        &--select{
          background: #27b8d0;
        }
      }
      &__modal{
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.2);
        z-index: 5;
      }
    }
    &-option{
      position: absolute;
      left: 80px;
      top: 0;
      width: 280px;
      min-height: calc(100vh - 60px);
      height: 100%;
      z-index: 10;
      background: #ffffff;
      font-size: 12px;
      &__module{
        margin: 15px 0 15px 10px;
        color: #C0C4CC;
        font-weight: bold;
        z-index: 9;
      }
      &__item{
        margin: 12px 30px;
        color: #666666;
        font-weight: lighter;
        &:hover{
          cursor: pointer;
          opacity: .8;
        }
        &--title{
          margin: 15px 0;
          transform: translateX(-15px);
          color: #fca605;
          &:hover{
            cursor: default;
            opacity: 1;
          }
        }
      }
    }
    &__right{
      width: 1840px;
      background: #f1f4ff;
      ::v-deep{
        .el-input__inner{
          border-radius: 0;
        }
      }
    }
    &-component{
      margin: auto;
      box-sizing: border-box;
      background: #ffffff;
      padding: 10px;
      border-radius: 5px;
      box-shadow: 3px 5px 4px 2px rgba(0, 0, 0, .2);
    }
  }
  &-dialog{
    &__img{
      width: 1000px;
    }
  }
}
</style>
